import React, { useEffect } from 'react';
import ListTableView from './ListTableView';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useStyles from '../index.style';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getContactContainerHeight } from '@jumbo/constants/AppConstants';
import EmptyResult from './EmptyResult';
import DownloadItemHeader from './DownloadItemHeader';
import { useLocation } from 'react-router';
import { getRelations } from 'redux/actions/RelationManager';

const RelationList = ({ width }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { relationsList } = useSelector(({ relations }) => relations);

  const params = new URLSearchParams(location.search);
  const id = params.get('movie');

  useEffect(() => {
    dispatch(getRelations(id));
  }, [id, dispatch]);

  const classes = useStyles({
    height: getContactContainerHeight(width),
  });

  return (
    <Box className={classes.inBuildAppCard}>
      <DownloadItemHeader enableCreateItem={id === 'null' ? false : true} />
      {relationsList.length > 0 ? (
        <Box className={classes.inBuildAppMainContent}>
          <PerfectScrollbar className={classes.perfectScrollbarContactCon}>
            <ListTableView />
          </PerfectScrollbar>
        </Box>
      ) : (
        <Box className={classes.inBuildAppMainContent}>
          <EmptyResult />
        </Box>
      )}
    </Box>
  );
};

export default RelationList;

RelationList.prototype = {
  onShowContactDetail: PropTypes.func,
};
